<template>
  <div class="login">
    <div class="login_main flex">
      <img src="../assets/login_left_bg.png" class="login_left_bg" alt="" />
      <div class="login_form" id="form">
        <!-- <p class="login_title">教师登录</p> -->
        <div class="login_tabs flex">
          <p :class="loginType == 1? 'login_title active':'login_title'" @click="changeLogin(1)">教师登录</p>
          <p :class="loginType == 2? 'login_title active':'login_title'" @click="changeLogin(2)">机构登录</p>
        </div>
        <div>
          <input
            type="text"
            class="login_phone"
            placeholder="手机号"
            v-model.trim="info.phone"
          />
        </div>
        <div class="login_li flex">
          <input
            type="text"
            class="login_verify"
            placeholder="验证码"
            v-model.trim="info.verifyCode"
            @keydown.enter="login"
          />
          <span class="verify_code_btn" @click="sendVerifyCode">{{
            verifyBtnTitle
          }}</span>
        </div>
        <button class="login_btn" @click="login">登录</button>
        <button class="register_btn" @click="register">立即注册</button>
      </div>
    </div>
    <router-link to="/home">
      <img
        src="../assets/index_header_logo.png"
        class="login_logo"
        alt="青新学吧"
      />
    </router-link>
  </div>
  <p class="login_footer">© 2022 青岛新闻网络传播有限公司 保留所有权利</p>
</template>

<script>
import { getVerifyCode } from "../server/verify_code";
import { userLogin,orgLogin } from "../server/user_login";
// 引入good-storage插件，用来保存登录后的token
import storage from "good-storage";
import { LOCAL_STORAGE_KEY_TOKEN,LOCAL_STORAGE_KEY_ROLE } from "../common/js/const";

export default {
  data() {
    return {
      info: {
        phone: "",
        verifyCode: "",
      },
      loginType: 1,
      countDown: 60,
      waiting: false,
    };
  },
  computed: {
    verifyBtnTitle: {
      get() {
        if (this.waiting) {
          return `重新发送(${this.countDown})`;
        } else {
          return "获取验证码";
        }
      },
    },
  },
  methods: {
    //切换登录角色
    changeLogin(type){
      console.log(type);
      this.loginType = type
    },
    // 获取验证码
    sendVerifyCode() {
      if (this.waiting) {
        // 等待倒计时结束
        return;
      }
      if (this.info.phone.length == 0) {
        alert("请输入手机号");
      } else {
        getVerifyCode(this.info.phone);
        this.waiting = true;
        this.countDown = 60;
        this.countDownTimer = setInterval(() => {
          this.countDown -= 1;
          if (this.countDown <= 0) {
            // 清除倒计时Timer
            clearInterval(this.countDownTimer);
            // 重置参数
            this.waiting = false;
          }
        }, 1000);
      }
    },
    login(){
      if (this.loginType == 1) {
        this.userLogin()
      }
      if(this.loginType == 2){
        this.orgLogin()
      }
    },
    // 用户登录
    async userLogin() {
      if (this.info.phone.length == 0) {
        alert("请输入手机号");
      } else if (this.info.verifyCode.length == 0) {
        alert("请输入验证码");
      } else {
        let respObj = await userLogin(this.info.phone, this.info.verifyCode);
        if (respObj != false) {
          // 保存服务端返回的token
          storage.set(LOCAL_STORAGE_KEY_TOKEN, respObj.token);
          storage.set(LOCAL_STORAGE_KEY_ROLE, 'teacher');
          // 后退回登录前的页面
          this.$router.push({ path: "/" });
        }
      }
    },
    // 机构登录
    async orgLogin() {
      if (this.info.phone.length == 0) {
        alert("请输入手机号");
      } else if (this.info.verifyCode.length == 0) {
        alert("请输入验证码");
      } else {
        let respObj = await orgLogin(this.info.phone, this.info.verifyCode);
        if (respObj != false) {
          // 保存服务端返回的token
          storage.set(LOCAL_STORAGE_KEY_TOKEN, respObj.token);
          storage.set(LOCAL_STORAGE_KEY_ROLE, 'org');
          // 后退回登录前的页面
          this.$router.push({ path: "/organization/jbxx" });
        }
      }
    },
    // 用户注册
    register() {
      this.$router.replace({
        name: "Register",
      });
    },
  },
  beforeUnmount() {
    // 清除倒计时Timer
    clearInterval(this.countDownTimer);
  },
};
</script>

<style scoped>
.login {
  position: fixed;
  top: 0;
  background: url(../assets/login_bg.png) no-repeat center;
  height: 100%;
  width: 100%;
  background-size: cover;
  overflow: scroll;
}

.login_main {
  width: 1200px;
  margin: 0 auto;
}

.login_logo {
  width: 141px;
  height: auto;
  position: fixed;
  top: 30px;
  left: 30px;
}

.login_left_bg {
  width: 768px;
  height: auto;
}

.login_form {
  width: 414px;
  height: 498px;
  margin-top: 180px;
  padding: 60px 42px;
  background-color: white;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}

.login_title {
  display: inline-block;
  font-size: 16px;
  color: #151515;
  font-weight: normal;
  line-height: 16px;
  padding-bottom: 18px;
  position: relative;
  margin-right: 30px;
  cursor: pointer;
}
.login_title.active{
  font-weight: 600;
  font-size: 20px;
}

.login_title.active::after {
  content: "";
  position: absolute;
  width: 80px;
  height: 6px;
  background-color: #003399;
  bottom: 0px;
  left: 50%;
  margin-left: -40px;
}

.login_phone {
  margin-top: 30px;
  width: 330px;
  padding: 13px 15px;
  box-sizing: border-box;
  border: 1px solid #d4d9e2;
  border-radius: 4px;
}

.login_li {
  border: 1px solid #d4d9e2;
  border-radius: 4px;
  margin-top: 30px;
  box-sizing: border-box;
  width: 330px;
  align-items: center;
}

.login_verify {
  width: 220px;
  padding: 13px 15px;
  box-sizing: border-box;
  border: 0px;
}

.verify_code_btn {
  color: #003399;
  font-size: 14px;
  cursor: pointer;
  margin: auto;
}

.login_btn {
  margin-top: 67px;
  width: 330px;
  height: 48px;
  background-color: #003399;
  border-radius: 4px;
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
}

.register_btn {
  margin-top: 10px;
  width: 330px;
  height: 48px;
  font-size: 14px;
  color: #003399;
  background-color: white;
  border-width: 0px;
  cursor: pointer;
}

.login_footer {
  position: fixed;
  bottom: 25px;
  left: 0px;
  right: 0px;
  text-align: center;
  font-size: 14px;
  color: #707070;
  line-height: 20px;
}
</style>